export const sendMetric = (event) => {
    if (!window.dataLayer) window.dataLayer = [];

    window.dataLayer.push({event});
};
